import { Component, Input, OnInit, Output, EventEmitter, Signal, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideAngularModule, User, ChevronDown, MessageSquare } from 'lucide-angular';
import { AuthService } from '../../../core/services/auth.service';
import { User as UserModel } from '../../../core/models/auth.model';
import { PatrolAlertsComponent } from '../../../features/patrol-alerts/components/alerts-component/patrol-alerts.component';
import { Company } from '../../../core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, LucideAngularModule, PatrolAlertsComponent],
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit {
  @Input() pageTitle = 'Dashboard';
  @Input() breadcrumbs: string[] = [];
  @Output() openUserProfile = new EventEmitter<void>(); // Apenas o Output

  currentUser: UserModel | null = null;
  company = signal<Company | null>(null);
  readonly UserIcon = User;
  readonly ChevronDownIcon = ChevronDown;
  readonly MessageSquare = MessageSquare;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.company.set(this.getCompany());
  }

  // Método que emite o evento
  onOpenUserProfile(): void {
    this.openUserProfile.emit();
  }

  getUserDisplayName(): string {
    return this.currentUser
      ? `${this.currentUser.first_name} ${this.currentUser.last_name}`
      : 'Usuário';
  }

  getUserRole(): string {
    if (!this.currentUser) return '';

    const roleLabels: { [key: string]: string } = {
      admin: 'Administrador',
      manager: 'Gerente',
      supervisor: 'Supervisor',
      operator: 'Operador',
      user: 'Usuário',
      guard: 'Vigilante',
    };

    return (
      roleLabels[this.currentUser?.role_settings?.designation || this.currentUser?.role] ||
      this.currentUser?.role
    );
  }
  getCompany(): Company | null {
    const currentUser = this.authService.getCurrentUser();

    return currentUser?.company || null;
  }
  navigateToChat(): void {
    const currentUser = this.authService.getCurrentUser();
    const companyId = currentUser?.company_id;

    const baseUrl = window.location.origin;

    const url = companyId ? `${baseUrl}/chat?company_id=${companyId}` : `${baseUrl}/chat`;

    window.open(url, '_blank', 'noopener,noreferrer');
  }

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = '/logo.png';
  }
}
